const TYPE = "sequenciaPedidoWeb";

const sequenciaPedidoModule = {
  get: async (dbConnection) => {
    let sequencia = null;
    let idUsuario = localStorage.getItem("idUsuario");
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        idUsuario: { $eq: idUsuario },
      },
    });

    if (result.docs.length) {
      sequencia = result.docs[0];
    } else {
      sequencia = {
        sequencia: 1,
        type: TYPE,
        idUsuario: idUsuario,
      };
      await dbConnection.post(sequencia);
    }

    return sequencia.sequencia;
  },

  increment: async (dbConnection) => {
    let sequencia = null;
    let idUsuario = localStorage.getItem("idUsuario");
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        idUsuario: { $eq: idUsuario },
      },
    });

    if (result.docs.length) {
      sequencia = result.docs[0];
    }

    sequencia.sequencia++;
    await dbConnection.post(sequencia);

    return sequencia.sequencia;
  },
};
export default sequenciaPedidoModule;
